export enum LoadingErrorType {
  CannotGetProfile = "cannot-get-profile",
  CannotGetContracts = "cannot-get-contracts",
  CannotGetBills = "cannot-get-bills",
  CannotGetUsageData = "cannot-get-usagedata",
  CannotUploadImage = "cannotUploadImage",
  CannotDeleteImage = "cannotDeleteImage",
}

export enum UserRoleEnum {
  PRIVATE = "PRIVATE",
  COMPANY = "COMPANY",
  CONDOMINIUM_ADMIN = "CONDOMINIUM_ADMIN",
  MUNICIPAL_USER = "MUNICIPAL_USER",
  MANAGER = "MANAGER",
  OPERATOR = "OPERATOR",
  MUNICIPAL_OPERATOR = "MUNICIPAL_OPERATOR",
  PARTNER = "PARTNER",
}

export enum UserNotificationTypes {
  ALERT = "ALERT",
  WARNING = "WARNING",
  INFO = "INFO",
  GENERIC = "GENERIC",
}

export enum AttachmentType {
  ALERT = "ALERT",
  WARNING = "WARNING",
  INFO = "INFO",
  GENERIC = "GENERIC",
  VERBAL = "VERBAL",
  SIMPLE_CASE = "SIMPLE_CASE",
}

export enum CaseForms {
  Test = "TEST",
  DomiciliazioneBancariaComplex = "BANK_DOMICILIATION",
  Empty = "EMPTY",
  DenunciaPerdite = "LEAK_REPORTING",
  Voltura = "REG_TRANSFER",
  Subentro = "TAKEOVER",
  TutelaPerdite = "LEAK_PROTECTION",
  RichiediSpurghiCase = "GESTIONE_SPURGO",
  RichiediInformazioni = "RICHIESTA_INFORMAZIONI",
  Autolettura = "AUTOLETTURA",
  AvvenutoPagamento = "RECUPERO_CREDITI",
  DomiciliazioneBancaria = "ADESIONE_SEPA",
  RateizzazioneBolletta = "RATEIZZAZIONE_PAGAMENTO",
  DisattivazioneDellaFornitura = "DISATTIVAZIONE_PUF",
  RettificaFatturazione = "RETTIFICA_FATTURAZIONE",
  FaiUnReclamo = "GESTIONE_RECLAMI",
  PreventivoLavori = "ESECUZIONI_LAVORI_PUF",
  AnalisiAcqua = "ANALISI_ACQUA",
  SegnalaUnGuasto = "PRONTO_INTERVENTO",
  AppuntamentoPuntoAcqua = "APPUNTAMENTO",
  VerificaMetrica = "VERIFICA_METRICA",
  EstensioneReteEsistente = "ESTENSIONE_RETE",
  VerificaContatore = "VERIFICA_MISURATORE",
  VerificaDellaPressione = "VERIFICA_PRESSIONE",
  ModificaDati = "MODIFICHE_ANAGRAFICHE",
  Fognatura = "SEWER_CONNECTION",
  Allaccio = "AQUEDUCT_CONNECTION",
  LetturaSicuraAttiva = "LETTURA_SICURA_ATTIVA",
  LetturaSicuraDisattiva = "LETTURA_SICURA_DISATTIVA",
  RichiediOmaggio = "SPEDIZIONE_OMAGGIO",
  SpidRegister = "SPID_REGISTER",
  AggiornaDati = "AGGIORNA_DATI",
  VolturaMortisCausa = "HEIR_TRANSFER",
  ModificaDomiciliazioneBancariaComplex = "MODIFY_BANK_DOMICILIATION",
  AssociaContrattoAmministratore = "ASSOCIA_CONTRATTO_AMMINISTRATORE",
}
export enum PageForms {
  SelfReadingOperator = "SELF_READING_OPERATOR",
}

export enum ComplexCaseType {
  TAKEOVER = "TAKEOVER",
  REG_TRANSFER = "REG_TRANSFER",
  SEWER_CONNECTION = "SEWER_CONNECTION",
  AQUEDUCT_CONNECTION = "AQUEDUCT_CONNECTION",
  LEAK_PROTECTION = "LEAK_PROTECTION",
  LEAK_REPORTING = "LEAK_REPORTING",
  BANK_DOMICILIATION = "BANK_DOMICILIATION",
  HEIR_TRANSFER = "HEIR_TRANSFER",
}

export enum CaseMutationType {
  Simple = "SIMPLE",
  Complex = "COMPLEX",
  Custom = "Custom",
}

export enum AccountHolderType {
  OWNER = "OWNER",
  TENANT = "TENANT",
  LEGAL_REPRESENTATIVE = "LEGAL_REPRESENTATIVE",
  USUFRUCTUARY = "USUFRUCTUARY",
  OTHER = "OTHER",
  CONDOMINIUM_ADMIN = "CONDOMINIUM_ADMIN",
}
export enum RelationshipType {
  SPOUSE = "coniuge",
  SON = "figlio",
  PARENT = "genitore",
  OTHER = "altro",
}
export enum TypeHeir {
  SOLE = "SOLE",
  DELEGATED = "DELEGATED",
}

export enum DeclarationType {
  OWNER = "OWNER",
  OTHER = "OTHER",
  BUILDING = "BUILDING",
  SCIA = "SCIA",
  DIA = "DIA",
  HOUSE_AGE = "HOUSE_AGE",
  OUTLET_DIVISION = "OUTLET_DIVISION",
  POSSESSION = "POSSESSION",
}
export enum SupplySewerType {
  MIXED = "MIXED",
  SEPARATE = "SEPARATE",
}
export enum SupplyUserType {
  AQUEDUCT = "AQUEDUCT",
  PRIVATE_WELL = "PRIVATE_WELL",
}

export enum AreaClassification {
  RESIDENT_DOMESTIC_USE = "RESIDENT_DOMESTIC_USE",
  NOT_RESIDENT_DOMESTIC_USE = "NOT_RESIDENT_DOMESTIC_USE",
  CONDOMINIUM_USE = "CONDOMINIUM_USE",
  INDUSTRIAL_USE = "INDUSTRIAL_USE",
  ARTISAN_AND_COMMERCIAL_USE = "ARTISAN_AND_COMMERCIAL_USE",
  AGRICULTURAL_AND_ZOOTECHNICAL_USE = "AGRICULTURAL_AND_ZOOTECHNICAL_USE",
  PUBLIC = "PUBLIC",
  FIREFIGHTING = "FIREFIGHTING",
  BUILDING_SITE = "BUILDING_SITE",
  OTHER = "OTHER",
  OTHER_USE = "OTHER_USE",
}

export enum CaseSubTypes {
  SIMPLE = "SIMPLE",
  ACTIVE_USER = "ACTIVE_USER",
  ADHESION_REQUEST = "ADHESION_REQUEST",
  LEAD_DENOUNCE = "LEAD_DENOUNCE",
  SEWER = "SEWER",
  SEWER_EXT = "SEWER_EXT",
  WATER = "WATER",
  WATER_EXT = "WATER_EXT",
}

export enum TipologiaUsoFornitura {
  DOMESTICO = "DOMESTICO",
  NON_DOMESTICO = "NON_DOMESTICO",
}
export enum TipologiaInterventoSpurgho {
  PROGRAMMED = "SCHEDULED_AID",
  EMERGENCY_SERVICE = "FIRST_AID",
}
export enum TipologiaIntestatario {
  PROFESSIONISTA = "PROFESSIONISTA",
  MICROIMPRESA = "MICROIMPRESA",
  NESSUNA = "NESSUNA",
}

export enum TipologiaUsoFornituraFognatura {
  ACQUEDOTTO = "ACQUEDOTTO",
  POZZO_PRIVATO = "POZZO_PRIVATO",
}

export enum TipologiaUsoTipoImmissione {
  INDUSTRIALI = "ACQUE_REFLUE_INDUSTRIALI",
  CIVILE_DOMESTICO = "ACQUE_REFLUE_CIVILE_DOMESTICO",
  CIVILE_NON_DOMESTICO = "ACQUE_REFLUE_CIVILE_NON_DOMESTICO",
}

export enum TipoFognatura {
  MISTO = "MISTO",
  SEPARATO = "SEPARATO",
}

export enum TipoBollettaRecapito {
  NUOVO = "NUOVO",
  PRE_ESISTENTE = "PRE_ESISTENTE",
}

export enum PersonType {
  LEGAL = "LEGAL",
  NATURAL = "NATURAL",
}

export enum PersonSex {
  F = "F",
  M = "M",
}

export enum Unita {
  ABITATIVA = "HOUSING",
  NONE_ABITATIVA = "NOT_HOUSING",
}
export enum Authorization {
  AUTORIZZO = "AUTORIZZO",
  NONE_AUTORIZZO = "NONE_AUTORIZZO",
}
export enum BirthCountries {
  ITALY = "I",
  FOREIGN = "F",
}
export enum CaseState {
  Complete = "COMPLETE",
  Incomplete = "INCOMPLETE",
}

export enum PersonRoleType {
  CONTRACT_HOLDER = "CONTRACT_HOLDER",
  LEGAL_REPRESENTATIVE = "LEGAL_REPRESENTATIVE",
  OTHER = "OTHER",
}

export enum CadastreType {
  AGRICULTURAL_LAND = "AGRICULTURAL_LAND",
  MANUFACTURED = "MANUFACTURED",
  NON_STACKABLE_PROPERTY = "NON_STACKABLE_PROPERTY",
  PROPERTY_NOT_STACKED = "PROPERTY_NOT_STACKED",
}

export enum RichiediOmaggioTipi {
  KIT_RUBINETTO = "KIT_TAP",
  TEMPORIZZATORE_DOCCIA = "SHOWER_TIMER",
  SACCHETTO_INGANNA_SCIACQUONE = "BAG",
}

export enum GraphQLErrors {
  "string_email_already_exists" = "string_email_already_exists",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  INVALID_FIELD = "INVALID_FIELD",
  SAFOS_ERROR = "SAFOS_ERROR",

  SAFO = "SAFOS_ERROR",
  FORBIDDEN_ERROR = "FORBIDDEN_ERROR",
  "missing_attachments" = "missing_attachments",
  "custom_fiscal_code_surname_congruency" = "custom_fiscal_code_surname_congruency",
  "custom_fiscal_code_name_congruency" = "custom_fiscal_code_name_congruency",
  "number_max" = "number_max",
  "string_username_already_exists" = "string_username_already_exists",
  "custom_fiscalcode_or_piva" = "custom_fiscalcode_or_piva",

  error_network = "cannot-get-profile",
}
export enum GenericErrorEnum {
  NotAuthorizedException = "NotAuthorizedException",
  PasswordResetRequiredException = "PasswordResetRequiredException",
  InvalidParameterException = "InvalidParameterException",
  LimitExceededException = "LimitExceededException",
  CodeMismatchException = "CodeMismatchException",
  UserLambdaValidationException = "UserLambdaValidationException",
}

export const allowedImagesExtensions = ["jpg", "jpeg", "png"];

export enum CustomerSearchType {
  "EMAIL" = "Email",
  "EMAIL_SPID" = "Email SPID",
  "FISCAL_CODE" = "Codice fiscale",
  "PIVA" = "Partita IVA",
}

export enum CaseStepperType {
  Simple = "SIMPLE",
  None = "NONE",
  Full = "FULL",
}

interface EnumItem<E> {
  value: string;
  label: string;
}

export function enumToArray(Enum: Record<string, any>): EnumItem<any>[] {
  return Object.keys(Enum)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({ label: (Enum as any)[key], value: key } as EnumItem<any>));
}

export enum ContractStatusCodeEnum {
  CA00 = "active", //Attivo
  FC00 = "inactive", //Fine Contratto
  CU00 = "inactive", //Comune Uscito
  AA00 = "in_progress", //Attesa allacciamento
  GANA = "inactive", //Disattivazione fornitura
  AS00 = "inactive", //Attesa subentro
  CM00 = "inactive", //Rimosso per morosita' (Riattivabile)
  SF00 = "inactive", //Sospensione Fatturazione
  FC01 = "inactive", //Fine contratto ultima fatturazione
  AR00 = "inactive", //Attesa di rimozione
  AA01 = "in_progress", //Attesa attivazione
  GAN1 = "inactive", //Disattivazione (Attesa ultima bolletta)
  CMN0 = "inactive", //Chiusura Morosita' Non Effettuata
  ALGA = "inactive", //Attesa attivazione
  AW01 = "active", //Attesa validazione
  CM01 = "inactive", //Attesa rimozione morosita'
  RM00 = "inactive", //Richiesta chiusura morosita'
  ASU1 = "inactive", //Attesa subentro
  CMD0 = "inactive", //Chiusura Morosita' Definitiva
  GAN0 = "inactive", //Attesa disattivazione
  CM02 = "inactive", //Riattivazione morosità (Attesa attivazione)
}

export enum LanguagesEnum {
  default = "it-IT",
  it = "it-IT",
  en = "en-EN",
}

export enum LanguagesNavigationEnum {
  it = "Italiano",
  en = "English",
}

export enum CookieLanguageInfoEnum {
  name = "language",
  path = "/",
}

export enum AnalisiAcquaType {
  base = "BASE_CHECK",
  completo = "COMPLETE_CHECK",
  avanzato = "ADVANCED_CHECK",
}
export enum ComplexCaseSubType {
  SEWER = "SEWER",
  SEWER_EXT = "SEWER_EXT",
  WATER = "WATER",
  WATER_EXT = "WATER_EXT",
}

export enum SupplyWaterType {
  DOMESTIC = "DOMESTIC",
  NOT_DOMESTIC = "RAINWATER",
  INDUSTRIAL = "INDUSTRIAL",
}
export enum SimpleCaseType {
  TAP_KIT = "TAP_KIT",
  SHOWER_TIMER = "SHOWER_TIMER",
  TOILET_FLUSH_BAG = "TOILET_FLUSH_BAG",
  SERVICE_AQUEDUCT = "SERVICE_AQUEDUCT",
  SERVICE_SEWER = "SERVICE_SEWER",
}

export enum ComplexCaseStatusEnum {
  NOT_COMPLETED = "NOT_COMPLETED",
  COMPLETED = "COMPLETED",
  DELETED = "DELETED",
  WAITING_SIGN = "WAITING_SIGN",
}

export enum SelfReadingOperatorSearchType {
  CONTRACT_CODE = "contractId",
  CLIENT_CODE = "integraClientCode",
  PUF_CODE = "pufCode",
  METRE_CODE = "metreSerialNumber",
}
export enum PaymentType {
  BANK = "BANK_TRANSFER",
  CREDIT_CARD = "CREDIT_CARD",
}
export enum AnalisiAcquaPrices {
  base = 40,
  completo = 60,
  avanzato = 100,
}
